export const SET_PENDING_REQUESTS = 'SET_PENDING_REQUESTS';
export const REMOVE_FROM_PENDING_REQUESTS = 'REMOVE_FROM_PENDING_REQUESTS';
export const CLEAR_PENDING_REQUESTS = 'CLEAR_PENDING_REQUESTS';
